import IncidentRosterData from 'components/IncidentConfig/IncidentRosterData';
import { HwcgContactListsView } from 'components/MapPage/CorporateViewTabs/ContactListsTab/HwcgContactListsView';

export const LIAISON_SEAT_SLUG = 'liaison-officer';

/**
 * The Liaison Officer's incident roster, where external users are assigned to
 * positions, and partner contacts.
 */
export function LiaisonWorkspaceSections() {
  return (
    <>
      <section
        className="tw:flex tw:flex-col tw:gap-3"
        data-tour="liaison-roster"
      >
        <h2 className="tw:m-0 tw:text-base tw:font-medium">Incident Roster</h2>
        <p className="tw:m-0 tw:text-sm tw:text-muted-foreground">
          Assign agency representatives and other external users to any position
          from its assignee menu.
        </p>
        <IncidentRosterData />
      </section>
      <section
        className="tw:flex tw:min-w-0 tw:flex-col tw:gap-3"
        data-tour="liaison-contact-list"
      >
        <h2 className="tw:m-0 tw:text-base tw:font-medium">Contact List</h2>
        <HwcgContactListsView embedded />
      </section>
    </>
  );
}
